<template lang="pug">
  #js-icon.modal.fade
    .modal-dialog.modal-dialog-centered
      .modal-content
        .modal-header
          h5.modal-title
            | アイコンの画像を設定
        .modal-body
          .cropper(v-if="imgSrc")
            VueCropper.cropper__img(
              ref="cropper",
              :src="imgSrc",
              :aspect-ratio="1",
              :viewMode="1"
            )

        .modal-footer
          button.btn.btn-action(
            type="button",
            data-dismiss="modal"
          )
            | キャンセル
          button.btn.btn-primary(
            type="button",
            @click="save",
            :disabled="!imgSrc"
          )
            | 保存
</template>

<script>
import $ from 'jquery'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import ImageResize from 'image-resize'

export default {
  name: 'Icon',
  components: {
    VueCropper
  },
  data () {
    return {
      imgSrc: ''
    }
  },
  mounted () {
    // モーダルが見えるようになったら発火
    $('#js-icon').on('shown.bs.modal', () => {
      this.imgSrc = this.$store.state.iconImg
    })

    $('#js-icon').on('hidden.bs.modal', () => {
      this.imgSrc = ''
    })
  },
  methods: {
    async save () {
      // vue-cropperjsで、切り取った画像
      const cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()

      const imageResize = new ImageResize({ width: 200 })

      // リサイズした画像（デフォルトのqualityが.75なので、約10kBになる）
      const resizeImg = await imageResize.play(cropImg)
        .then((res) => res)
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err)
        })

      const payload = {
        type: 'users',
        peerId: this.$store.state.peerId,
        data: {
          icon: resizeImg
        }
      }

      this.$store.state.room.send(payload)
      this.$store.dispatch('updateUsers', { payload })
      localStorage.setItem('goqmeLocalIcon', resizeImg)

      $('#js-icon').modal('hide')
    }
  }
}
</script>
<style lang="scss" scoped>
.cropper {
  &__img {
    max-height: 400px;
  }
}

// scopedはずし
.cropper ::v-deep {
  .cropper-view-box,
  .cropper-face {
      border-radius: 50%;
  }
}
</style>
